module.exports = __webpack_public_path__ + "static/img/xj_img8.bcebb6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj_img8.jpg
// module id = 3fMD
// module chunks = 4